export interface PlatformConfigInterface {
    buildNumber: string
    environmentTag: string
}

export const platformConfig: PlatformConfigInterface = {
    buildNumber: process.env.REACT_APP_JENKINS_BUILD_NUMBER as string,
    environmentTag: process.env.REACT_APP_BUILD_ENVIRONMENT as string
}
